module.exports = __webpack_public_path__ + "static/media/linfoma-grande.a80f8c63.jpg";